var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-hot',{attrs:{"styles":("flex-4 bg-color-neutral round-sm " + (_vm.tag_text? 'pad-r-1 pad-v-.4 pad-l-.4': '')),"hover":"bg-color-rgba(134,134,134,.24)","states":{
            act: {
                style: 'color-blue',
                state: _vm.selected
            }
        }},on:{"on_click":_vm.$_click}},[_c('b-view',{attrs:{"styles":"w-1.7 h-1.7 bg-color-neutral round-sm flex-5","states":{
                act: {
                    style: 'bg-color-blue color-light',
                    state: _vm.selected
                }
            }}},[_c('b-icon',{attrs:{"icon":"success","styles":"alpha-.3","states":{
                    act: {
                        style: 'alpha-1',
                        state: _vm.selected
                    }
                }}})],1),_vm._v(" "),(_vm.tag_text)?_c('b-view',{attrs:{"styles":"mrg-l-1"}},[_vm._v("\n        "+_vm._s(_vm.tag_text)+"\n    ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f489290","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BTXUI/checkbox/checkbox-widget.vue
// module id = null
// module chunks = 